import { toZonedTime } from 'date-fns-tz';
import { DateObject } from 'react-multi-date-picker';
import { DEFAULT_TIMEZONE, DEFAULT_DATE_MASK } from 'shared/mui/DatePicker/config/defaultValues';
import { parseDateInput } from 'utils/date';

/**
 * Преобразует входное значение даты в DateObject с учётом таймзоны.
 *
 * Сначала парсит input в Date, затем конвертирует из UTC в указанную таймзону.
 * Если дату невозможно распарсить возвращает null.
 *
 * @example
 * formatInputToDateObject('2024-01-01T10:00:00Z', 'Europe/Moscow')
 * // → DateObject с датой 01.01.2024 13:00
 */
export function formatInputToDateObject(
  input: unknown,
  timezone: string | null = DEFAULT_TIMEZONE,
): DateObject | null {
  const date = parseDateInput(input, { format: DEFAULT_DATE_MASK });

  if (!date || !timezone) {
    return null;
  }

  const zonedDate = toZonedTime(date, timezone);

  return new DateObject(zonedDate);
}
